<template>
  <div>
    <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end pt-3 pl-3 pr-3 mb-3">
      <div class="d-flex flex-column">
        <h4 class="mb-0">Sample Usage</h4>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>
 
    <CodePreviewViewer :viewMode="view" :codeSample="require('./multiselect_sample.js').default">
      <template v-slot:preview>
        <div class="bg-white rounded shadow-sm p-3 w-100">
          <MultiSelect v-model="selected" :value="selected" :options="options" canClear/>
          <p class="mt-2">Selected: <b>{{ selected }}</b></p>
        </div>
      </template>
    </CodePreviewViewer>
    </div>
  </div>
</template>
 
<script>
import MultiSelect from '@/components/export/MultiSelect/MultiSelect'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'
 
export default {
  components: { ButtonGroup, CodePreviewViewer, MultiSelect },
  data () {
    return {
      view: 'preview',
      selected: null,
      options: [
        { text: 'Aerospace', value: 'item_1' },
        { text: 'Agriculture', value: 'item_2' },
        { text: 'Computer and Technology', value: 'item_3' },
        { text: 'Construction', value: 'item_4' },
        { text: 'Economics', value: 'item_5' },
        { text: 'Education', value: 'item_6' },
        { text: 'Energy', value: 'item_7' },
        { text: 'Entertainment', value: 'item_8' },
        { text: 'Fashion', value: 'item_9' },
        { text: 'Finance', value: 'item_10' },
        { text: 'Food Industry', value: 'item_11' },
        { text: 'Gaming', value: 'item_12' },
        { text: 'Health Care', value: 'item_13' },
        { text: 'Hospitality', value: 'item_14' },
        { text: 'Insurance', value: 'item_15' },
        { text: 'Investment', value: 'item_16' }
      ]
    }
  }
}
</script>
 
<style>
 
</style>